import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { SortOrder } from '@/components/ui/table'
import { VendorModel, VisitorStatus } from '@/models'

export type GetVendorsRequest = {
  buildingId?: number
  search?: string
  filter?: string
  skip?: number
  limit?: number
  sort?: string
  direction?: SortOrder
}

export type GetVendorsResponse = {
  data: VendorModel[]
  countByStatus: Record<VisitorStatus, number>
  limit: number
  skip: number
  total: number
}

export const GET_VENDORS_BASE_QUERY_KEY = 'useGetVendors'

export const getVendorsQueryKey = (data: GetVendorsRequest) => [GET_VENDORS_BASE_QUERY_KEY, data]

export const getVendors = async (data: GetVendorsRequest): Promise<GetVendorsResponse> => {
  const response = await authAPI.get('/vendor', { params: data })
  return response.data
}

export const useGetVendors = (data: GetVendorsRequest) => {
  return useQuery({
    enabled: !!data.buildingId,
    gcTime: 0,
    placeholderData: keepPreviousData,
    queryFn: () => getVendors(data),
    queryKey: getVendorsQueryKey(data),
  })
}
